/**
 * Camino completo que pasa por un puerto, calculado sobre el grafo ya cargado.
 *
 * Se salta de puerto a puerto por los cables compartidos, nunca «por dentro» de
 * un equipo: empezar en el puerto 24 de un switch ilumina su latiguillo, la
 * boca del panel, el cable de pared y la toma (y lo que cuelgue de ella).
 *
 * Un puerto puede tener MÁS de un cable y el recorrido se ramifica:
 *   · boca de panel → latiguillo al switch + cable de pared + enlace de armario
 *   · toma de pared → cable de pared (por detrás) + latiguillo del equipo
 *
 * @param {Array} edges        aristas del grafo (`{ a, b, key, kind… }`)
 * @param {string} startPortKey puerto de partida (`switch_port:12`)
 * @param {(edge:object, index:number) => string} keyOf  clave con la que el
 *        lienzo identifica cada cable (por defecto `edge.key`)
 * @param {number} maxEdges    tope de cables por camino
 * @returns {{edges: Set<string>, ports: Set<string>}}
 */
export function tracePath(edges, startPortKey, keyOf = (edge) => edge.key, maxEdges = 400) {
  const result = { edges: new Set(), ports: new Set() };
  if (!startPortKey) return result;

  const byPort = new Map();
  (edges || []).forEach((edge, index) => {
    const key = keyOf(edge, index);
    [edge.a, edge.b].forEach((portKey) => {
      if (!portKey) return;
      if (!byPort.has(portKey)) byPort.set(portKey, []);
      byPort.get(portKey).push({ key, a: edge.a, b: edge.b });
    });
  });

  const queue = [startPortKey];
  result.ports.add(startPortKey);
  while (queue.length && result.edges.size < maxEdges) {
    const portKey = queue.shift();
    (byPort.get(portKey) || []).forEach((edge) => {
      if (result.edges.has(edge.key)) return;
      result.edges.add(edge.key);
      [edge.a, edge.b].forEach((other) => {
        if (other && !result.ports.has(other)) {
          result.ports.add(other);
          queue.push(other);
        }
      });
    });
  }

  return result;
}

export default tracePath;
